export default __webpack_public_path__ + "static/media/흑풍 the BLAST.cd66c1e9.svg";